import { addMonths, isBefore, startOfDay } from 'date-fns'

/**
 * 運行日の検索期間の上限（#4557）
 *
 * URL 由来の検索条件を扱う `tours-search.ts` と、検索フォームの入力を扱う
 * `tours-search-form-value.ts` の双方が使うため、循環参照を避けて独立させている。
 */

/** 運行日の検索期間の上限（月）。前年同月との比較を残すための Biz 判断（#4557） */
export const OPERATING_DATE_MAX_MONTHS = 12

/**
 * 運行日の期間が上限（OPERATING_DATE_MAX_MONTHS ヶ月）以内かどうかを判定する
 * @param from 開始日
 * @param to 終了日
 * @returns 上限以内であればtrue
 *
 * 例:
 * - 2026/01/01 ~ 2027/01/01 → true (OK)
 * - 2026/01/01 ~ 2027/01/02 → false (NG)
 * - 2026/01/31 ~ 2027/01/31 → true (OK)
 * - 2026/01/31 ~ 2027/02/01 → false (NG)
 */
export const isOperatingDateRangeWithinMaxMonths = (
  from: Date,
  to: Date
): boolean => {
  // 開始日に上限月数を加算した日付
  const limitDate = addMonths(startOfDay(from), OPERATING_DATE_MAX_MONTHS)
  // 終了日が上限日以前であればOK
  return (
    isBefore(startOfDay(to), limitDate) ||
    startOfDay(to).getTime() === limitDate.getTime()
  )
}
